var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab-view"},[_c('AppSystemInfoCard',{attrs:{"createdAt":_vm.book.createdAt,"updatedAt":_vm.book.updatedAt,"createdBy":_vm.book.createdBy.username,"updatedBy":_vm.book.lastModifiedBy.username}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }